import React, { useContext, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { store as mainStore } from '../../../../../store';
import { store } from './InsuranceSubtractions';
import Button from '@material-ui/core/Button';
import green from '@material-ui/core/colors/lightGreen';
import red from '@material-ui/core/colors/red';
import axios from '../../../../../api/axios';
import { formatNumber, toEN } from '../../../../../fns';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    flexFlow: 'row nowrap',
    '& > button:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  success: {
    background: green[300],
  },
  danger: {
    background: red[300],
  },
}));

const ISForm = () => {
  const classes = useStyles();
  const {
    showMessage,
    showError,
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  const {
    state: { insuranceSubtraction, error, isLoaded, page },
    dispatch,
    actions: { fetchingIS },
  } = useContext(store);
  const { _id: id, min, max, insurance } = insuranceSubtraction;

  const handleChange = (e) => {
    let { name, value } = e.target;
    value = toEN(value);
    dispatch({ type: 'CHANGE_FIELD', payload: { name, value } });
  };
  const [loading, setLoading] = useState(false);

  const validation = (e) => {
    const isSingleValidation = e || false;
    let er = {};

    // Validation patterns start here:
    if (!min) {
      er.min = 'این فیلد الزامی است.';
    }
    if (!max) {
      er.max = 'این فیلد الزامی است.';
    }
    if (!insurance) {
      er.insurance = 'این فیلد الزامی است.';
    }

    // Validation patterns end here.
    if (isSingleValidation) {
      let err = {};

      for (const v in insuranceSubtraction) {
        if (insuranceSubtraction[v]) {
          if (er[v]) {
            err[v] = er[v];
          }
        }
      }
      if (Object.entries(err).length) {
        dispatch({ type: 'ERROR', payload: err });
        return false;
      }
      {
        dispatch({ type: 'ERROR', payload: {} });
        return true;
      }
    } else {
      if (Object.entries(er).length) {
        dispatch({ type: 'ERROR', payload: er });
        return false;
      }
      dispatch({ type: 'ERROR', payload: er });
      return true;
    }
  };
  const handleAdd = async () => {
    if (!validation()) {
      showError('خطاهای مشخص شده را برطرف نمائید.');
      return;
    }
    try {
      setLoading(true);
      const {
        data: { messages },
      } = await axios.post(`/api/v1/admin/insuranceSubtractions`, {
        min,
        max,
        insurance,
      });
      showMessage(messages);
      const res = await fetchingIS(page, itemsCountPerPage);
      dispatch({ type: 'ISS_WITH_RESET_FORM', payload: res });
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = () => {
    dispatch({ type: 'RESET_FORM' });
  };
  const handleEdit = async () => {
    if (!validation()) {
      showError('خطاهای مشخص شده را برطرف نمائید.');
      return;
    }
    try {
      setLoading(true);
      const {
        data: { messages },
      } = await axios.put(`/api/v1/admin/insuranceSubtractions/${id}`, {
        min,
        max,
        insurance,
      });
      showMessage(messages);
      const res = await fetchingIS(page, itemsCountPerPage);
      dispatch({ type: 'ISS_WITH_RESET_FORM', payload: res });
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.root}>
      <TextField
        name="min"
        variant="outlined"
        size="medium"
        fullWidth
        onChange={handleChange}
        label="حداقل ارزش بار"
        value={min ? min : ''}
        onBlur={validation}
        error={error.min ? true : false}
        helperText={error.min ? error.min : ''}
      />

      <TextField
        name="max"
        variant="outlined"
        size="medium"
        fullWidth
        onChange={handleChange}
        label="حداکثر ارزش‌بار"
        type="number"
        value={max ? max : ''}
        onBlur={validation}
        error={error.max ? true : false}
        helperText={error.max ? error.max : ''}
      />
      <TextField
        name="insurance"
        variant="outlined"
        size="medium"
        fullWidth
        onChange={handleChange}
        label="بیمه‌بار(تومان)"
        value={insurance ? formatNumber(insurance) : ''}
      />
      <div className={classes.actions}>
        {insuranceSubtraction && insuranceSubtraction._id ? null : (
          <Button
            variant="contained"
            fullWidth
            size="large"
            className={classes.success}
            onClick={handleAdd}
            disabled={loading}
            endIcon={loading ? <CircularProgress size={10} /> : <></>}
          >
            افزودن
          </Button>
        )}
        {insuranceSubtraction && insuranceSubtraction._id ? (
          <Button
            variant="contained"
            fullWidth
            size="large"
            className={classes.success}
            onClick={handleEdit}
            disabled={loading}
            endIcon={loading ? <CircularProgress size={10} /> : <></>}
          >
            ویرایش
          </Button>
        ) : null}
        {insuranceSubtraction && insuranceSubtraction._id ? (
          <Button
            variant="contained"
            fullWidth
            size="large"
            className={classes.danger}
            onClick={handleCancel}
          >
            صرفنظر
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(ISForm);
